import script from "./ManageProgramBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageProgramBox.vue?vue&type=script&setup=true&lang=js"

import "./ManageProgramBox.vue?vue&type=style&index=0&id=77d0e626&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77d0e626"]])

export default __exports__